"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.SIZE=void 0;// eslint-disable-next-line import/prefer-default-export
var SIZE={MEDIUM:"medium",SMALL:"small"};exports.SIZE=SIZE;